import React from 'react';
import { motion } from 'framer-motion';
import './BloodHeader.css';

const BloodHeader = () => {
  return (
    <motion.header 
      className="blood-header"
      initial={{ y: -200 }}
      animate={{ y: 0 }}
      transition={{ type: 'spring', bounce: 0.5 }}
    >
      <h1 className="main-title">
        <span className="blood-text">BLOOM</span>
        <span className="blast-text">BLAST</span>
      </h1>
      
      <motion.div 
        className="chainsaw-icon"
        animate={{ 
          rotate: [0, 10, -10, 10, 0],
          scale: [1, 1.1, 1]
        }}
        transition={{ duration: 2, repeat: Infinity }}
      >
        ⛓️🪚⛓️
      </motion.div>
      
      <p className="subtitle">GALLERY OF CHAINSAW MAN</p>
      
      {}
      <div className="blood-background">
        {[...Array(30)].map((_, i) => (
          <motion.div
            key={i}
            className="blood-particle"
            initial={{ 
              x: Math.random() * window.innerWidth,
              y: -100
            }}
            animate={{ 
              y: window.innerHeight + 100,
              x: Math.random() * window.innerWidth
            }}
            transition={{ 
              duration: Math.random() * 5 + 5,
              repeat: Infinity,
              delay: Math.random() * 5
            }}
          />
        ))}
      </div>
    </motion.header>
  );
};

export default BloodHeader;